import { styled } from '@/stitches.config';

interface SelectIcon {
  activeItems: number;
}

export function SelectIcon({ activeItems }: SelectIcon) {
  let viewBoxValues = updateViewBox(activeItems);

  function updateViewBox(activeEl: number): string | undefined {
    if (activeEl <= 0) {
      return (viewBoxValues = '0 0 64 64');
    }
    if (activeEl <= 1) {
      return (viewBoxValues = '0 17 64 64');
    }

    return (viewBoxValues = '0 18 64 64');
  }

  return (
    <Container>
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={viewBoxValues}
      >
        {activeItems <= 0 && (
          <path
            d="M37.3,26.6c-1.5,0-3.1-0.3-4.6-0.9l0,0c-3.3-1.2-5.9-3.7-7.3-6.9s-1.5-6.8-0.3-10C27.6,2.1,35.2-1.4,42,1.2
        c6.8,2.6,10.2,10.1,7.6,16.9C47.6,23.4,42.6,26.6,37.3,26.6z M37.4,2.5c-4.4,0-8.6,2.7-10.2,7.1c-1,2.7-0.9,5.7,0.3,8.4
        c1.2,2.7,3.4,4.7,6.1,5.7l0,0c5.6,2.1,12-0.7,14.1-6.4c2.1-5.6-0.7-12-6.4-14.1C39.9,2.8,38.6,2.5,37.4,2.5z"
          />
        )}

        {activeItems <= 1 && (
          <path
            d="M52,47.6c-1,0-2.1-0.2-3.1-0.6c-4.5-1.7-6.8-6.8-5.1-11.3c1.7-4.5,6.8-6.8,11.3-5.1c2.2,0.8,3.9,2.5,4.9,4.6
              c1,2.1,1,4.5,0.2,6.7C58.9,45.5,55.5,47.6,52,47.6z M52,32.3c-2.6,0-5.2,1.6-6.1,4.2c-1.3,3.4,0.4,7.2,3.8,8.5
              c1.6,0.6,3.4,0.6,5-0.2c1.6-0.7,2.8-2,3.4-3.7s0.6-3.4-0.2-5s-2-2.8-3.7-3.4C53.6,32.4,52.8,32.3,52,32.3z"
          />
        )}

        {activeItems <= 2 && (
          <path
            d="M18.8,63.6c-2.1,0-4.1-0.4-6.2-1.1l0,0C3.6,59.1-1,49,2.5,40C5.9,30.9,16,26.4,25,29.8c9,3.4,13.6,13.5,10.2,22.6
              C32.5,59.3,25.9,63.6,18.8,63.6z M13.4,60.5c7.9,3,16.7-1,19.7-8.9c3-7.9-1-16.7-8.9-19.7c-7.9-3-16.7,1-19.7,8.9
              C1.5,48.6,5.5,57.5,13.4,60.5L13.4,60.5z"
          />
        )}
      </svg>
    </Container>
  );
}

const Container = styled('div', {
  width: 20,
  height: 20,
  marginRight: '$3',

  svg: {
    fill: '$foreground',
  },
});
